import { useEffect } from 'react';

import { useDispatch } from 'react-redux';
import { Outlet } from 'react-router-dom';

import AuthModal from '@/components/AuthModal';
import ModalErrorUploadPdf from '@/components/ModalErrorUploadPdf';
import { useSaveGclid, useShallowEqualSelector } from '@/hooks';
import { fetchUser } from '@/store/profile/thunks';

import CheckoutLayout from '../CheckoutLayout';
import NoIndexMeta from '../NoIndexMeta';
import Scroller from '../Scroller';
import SeoTags from '../SeoTags';
import { useIsLoadingCheckout, useLayout } from '../hooks';
import Footer from './Footer/Footer';
import Header from './Header';

function PublicLayout({ preventIndexing }) {
	useLayout();
	useSaveGclid();
	const dispatch = useDispatch();
	const { pageNotFound, fetchUserCompleted } = useShallowEqualSelector(
		({ site, profile }) => ({
			pageNotFound: site.pageNotFound,
			fetchUserCompleted: profile.fetchUser.completed
		})
	);
	const isLoadingCheckout = useIsLoadingCheckout();

	useEffect(() => {
		if (!fetchUserCompleted) {
			dispatch(fetchUser());
		}
	}, []);

	if (isLoadingCheckout) {
		return <CheckoutLayout />;
	}

	return (
		<>
			<SeoTags />
			<Scroller />
			{preventIndexing && <NoIndexMeta />}
			<AuthModal />
			<Header />
			<ModalErrorUploadPdf />
			<Outlet />
			<Footer prefooter={!pageNotFound} />
		</>
	);
}

export default PublicLayout;
